const mapperCommitteesToAPI = form => {
    let committees = form.committees.map(response => {
        return {
            title: response.title,
            user_id: response.users.map(user => {
                return {
                    user_id: user.value,
                    type_of_user: 'evaluator',
                }
            }),
        }
    })

    return committees
}

export { mapperCommitteesToAPI }
